import isEmpty from "lodash/isEmpty"
import { countryAgeRequirements, isDateOfBirthValid } from "../utilities"

export default function validateInput(data) {
  const lang_code = localStorage.getItem("lang")

  const _country = localStorage.getItem("_country") || "GH"
  // Country-specific requirements for age
  const requiredAge = countryAgeRequirements[_country] || 18

  const lang_required = {
    fr: {
      message_required: `Ce champ est requis`,
    },
    en: {
      message_required: `This field is required`,
    },
    sw: {
      message_required: `Ni lazima kujaza nafasi hii`,
    },
    ZARMA: {
      message_required: `Tilas batamo hima ga bara`,
    },
    HAOUSSA: {
      message_required: `Doole hilin ga shina nan`,
    },
    es: {
      message_required: `Este campo es requerido`,
    },
    lb: {
      message_required: `This field is required`,
    },
    ar: {
      message_required: `هذا الحقل اجباري`,
    },
    pt: {
      message_required: `Este campo é obrigatório`,
    },
  }

  const lang_text_only = {
    fr: {
      message_required: `Entrer seulement du texte`,
    },
    en: {
      message_required: `Enter text only`,
    },
    sw: {
      message_required: `Ingiza herufi pekee`,
    },
    ZARMA: {
      message_required: `Zarma for Enter text only`,
    },
    HAOUSSA: {
      message_required: `Rubuta matani kaɗay`,
    },
    es: {
      message_required: `Inserta solo texto`,
    },
    lb: {
      message_required: `Enter text only`,
    },
    ar: {
      message_required: `ادخال احرف/ كلمات فقط`,
    },
    pt: {
      message_required: `Insira apenas texto`,
    },
  }

  const lang_phone_max_length = {
    fr: {
      message_required: `Le numéro de téléphone doit comporter 10 chiffres`,
    },
    en: {
      message_required: `Phone number should be 10 digits`,
    },
    sw: {
      message_required: `Namba ya simu mwisho ni tarakimu 10`,
    },
    ZARMA: {
      message_required: `Zarma for Phone number should be 10 digits`,
    },
    HAOUSSA: {
      message_required: `ỳan ƙilgo 10 ke cikin lamba waya`,
    },
    es: {
      message_required: `El número de teléfono debe tener 10 dígitos`,
    },
    lb: {
      message_required: `Phone number should be 10 digits`,
    },
    pt: {
      message_required: `O número de telefone deve ter 10 dígitos`,
    },
    ar: {
      message_required: `رقم الهاتف يجب ان يكون من ١٠ أرقام`,
    },
  }

  const min_date_msg = {
    fr: {
      message_required: `Format de date invalide ou ne répond pas aux exigences d'âge minimum de ${requiredAge} ans`,
    },
    en: {
      message_required: `Invalid date format or does not meet minimum age requirements of ${requiredAge} years`,
    },
    sw: {
      message_required: `Muundo wa tarehe si sahihi au haukidhi mahitaji ya chini ya umri wa miaka ${requiredAge}`,
    },
    ZARMA: {
      message_required: `Invalid date format or does not meet minimum age requirements of ${requiredAge} years`,
    },
    HAOUSSA: {
      message_required: `Tsarin kwanan wata mara inganci ko bai cika mafi ƙarancin shekarun buƙatun shekaru ${requiredAge} ba`,
    },
    es: {
      message_required: `Formato de fecha no válido o no cumple con los requisitos de edad mínima de ${requiredAge} años.`,
    },
    lb: {
      message_required: `Invalid date format or does not meet minimum age requirements of ${requiredAge} years`,
    },
    pt: {
      message_required: `Formato de data inválido ou não atende aos requisitos de idade mínima de ${requiredAge} anos`,
    },
    ar: {
      message_required: `تنسيق التاريخ غير صالح أو لا يستوفي متطلبات الحد الأدنى للعمر وهو ${requiredAge} عامًا`,
    },
  }

  let errors = {}
  const letters = /^[A-zÀ-ú\-\\' \u0600-\u06FF]+$/

  if (data.paysInterest === "") {
    errors.paysInterest = lang_required[lang_code].message_required
  }

  if (data.name === "") {
    errors.name = lang_required[lang_code].message_required
  }

  if (!data.name.match(letters)) {
    errors.name = lang_text_only[lang_code].message_required
  }

  if (data.phone_number !== "") {
    if (data.phone_number.length < 10) {
      errors.phone_number = lang_phone_max_length[lang_code].message_required
    }
  }

  if (data.role_in_group === "") {
    errors.role_in_group = lang_required[lang_code].message_required
  }

  if (data.gender === "") {
    errors.gender = lang_required[lang_code].message_required
  }

  if (!isDateOfBirthValid(data.date_of_birth, requiredAge)) {
    errors.date_of_birth = min_date_msg[lang_code].message_required
  }

  return {
    errors,
    isValid: isEmpty(errors),
  }
}
